import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 mt-32" data-testid="site-footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="text-muted-foreground text-sm leading-relaxed tracking-wide mt-6 max-w-sm">
              Articoli per la casa selezionati uno a uno: dispenser, borracce termiche,
              accessori per l'auto e tutto ciò che rende il quotidiano più semplice.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline-label mb-6">Esplora</p>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link to="/shop" className="hover:text-primary transition-colors" data-testid="footer-shop-link">Collezione</Link></li>
              <li><a href="/#filosofia" className="hover:text-primary transition-colors" data-testid="footer-philosophy-link">Filosofia</a></li>
              <li><Link to="/auth" className="hover:text-primary transition-colors" data-testid="footer-account-link">Account</Link></li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="overline-label mb-6">Assistenza</p>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Spedizione in 24/48h in tutta Italia<br />
              Reso facile entro 15 giorni<br />
              <a href="mailto:info@abfeliseshop.it" className="hover:text-primary transition-colors" data-testid="footer-info-email">info@abfeliseshop.it</a><br />
              <a href="mailto:ordini@abfeliseshop.it" className="hover:text-primary transition-colors" data-testid="footer-orders-email">ordini@abfeliseshop.it</a>
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-serif italic text-3xl md:text-4xl text-white/15 font-light">
            AB fëlise — le cose giuste, ogni giorno
          </p>
          <p className="text-xs text-muted-foreground tracking-[0.2em] uppercase">
            © {new Date().getFullYear()} AB fëlise shop
          </p>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-xs text-muted-foreground tracking-wide">
            <Link to="/privacy" className="hover:text-primary transition-colors" data-testid="footer-privacy-link">Privacy</Link>
            <Link to="/cookie-policy" className="hover:text-primary transition-colors" data-testid="footer-cookie-link">Cookie</Link>
            <Link to="/condizioni" className="hover:text-primary transition-colors" data-testid="footer-terms-link">Condizioni di vendita</Link>
            <Link to="/note-legali" className="hover:text-primary transition-colors" data-testid="footer-legal-notes-link">Note Legali</Link>
            <Link to="/spedizioni" className="hover:text-primary transition-colors" data-testid="footer-shipping-link">Spedizioni e consegne</Link>
            <Link to="/resi" className="hover:text-primary transition-colors" data-testid="footer-returns-link">Resi e rimborsi</Link>
            <Link to="/chi-siamo" className="hover:text-primary transition-colors" data-testid="footer-about-link">Chi siamo</Link>
          </div>
        </div>
        <div className="mt-8 text-[11px] text-muted-foreground/70 tracking-wide leading-relaxed" data-testid="footer-legal-address">
          <p>AB fëlise shop</p>
          <p>Via Mare, 62 - 89030 Condofuri (RC)</p>
          <p>P.IVA: 03383950809 · REA: RC-228077 · PEC: cristinamandalari@pec.it</p>
          <p>Email: ordini@abfeliseshop.it</p>
        </div>
      </div>
    </footer>
  );
}
